import { ItiBaseDto } from '@/iti-core-vue';
import { CollaborativeAreaMember } from './collaborative-area-member';
import { CollaborativeAreaType } from './collaborative-area-type';

export class CollaborativeArea extends ItiBaseDto {
    public name !: string;
    public description !: string;
    public active !: boolean;
    public type !: any; //CollaborativeAreaType || number;
    public users !: CollaborativeAreaMember[];
    public numberUsers !: number;
    public numberFiles !: number;
    public lastFileDate !: Date;
    public lastFileName !: string;
    public lastFileId!: number;
    public numberChatMessages !: number;
    public lastMessageDate !: Date;
    public lastMessage !: string;
    public roomId !: number;
    public lastPostId !: number
    public lastPostTitle !: string;
    public lastPostDate !: Date;
    public numberEvents !: number;
    public nextEventDate !: Date;
    public nameNextEvent !: string;
    public allDay !: boolean;
    public nameUsers !: string[];

}